// eslint-disable-next-line no-undef
export const isDevelopment = process.env.NODE_ENV !== "production";

// eslint-disable-next-line no-undef
export const frontendVersion = process.env.FRONTEND_VERSION;
